import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../Icons/SvgIcon';

var IconOff = function IconOff(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    width: 18,
    height: 18
  }, {
    children: _jsx("rect", {
      x: "1",
      y: "1",
      width: "16",
      height: "16",
      rx: "2",
      strokeWidth: "2"
    })
  }));
};

export default IconOff;